<!-- 信息公开详情 -->
<template>
  <div class="">
    <PCNavbar />
    <div class="main-wrap">
      <div class="block-wrap">
        <div class="article" v-if="pageType != 'zhengshu' && pageType != 'baogao'">
          <div class="article-title">{{ detail.title }}</div>
          <div class="article-info">{{ detail.time }}</div>
          <div class="article-content" v-html="detail.content"></div>
        </div>
        <el-image :src="imgsrc" style="width: 100%;" v-if="pageType == 'zhengshu'"></el-image>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { formatDate } from "@/utils/tools";
import { mapState } from "vuex";
import PCNavbar from "@/components/navbar/index";
import Footer from "@/components/footer/index";

export default {
  name: "PartyBuilding",
  components: { PCNavbar, Footer },
  data() {
    return {
      detail: {},
      imgsrc: '',
      pageType: '',
      baogao: {}
    };
  },
  computed: {
    ...mapState(["platform"]),
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      console.log(window.sessionStorage.getItem("detail"))
      if (this.$route.query && this.$route.query.pageType == 'zhengshu') {
        this.pageType = this.$route.query.pageType
        this.imgsrc = JSON.parse(window.sessionStorage.getItem("detail")).cover
      } else if (this.$route.query && this.$route.query.pageType == 'baogao') {
        this.pageType = this.$route.query.pageType
        this.baogao = {
          content_file: JSON.parse(window.sessionStorage.getItem("detail")).content_file,
          cover: JSON.parse(window.sessionStorage.getItem("detail")).cover,
          title: JSON.parse(window.sessionStorage.getItem("detail")).title
        }
      } else{
        const res = await CifuAPI.getArticleDetail({ id: this.$route.query.id });
        res.data.time = formatDate(res.data.show_time, "YYYY.MM.DD");
        this.detail = res.data;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.article {
  padding-top: 50px;
  margin-top: 50px;
  &-title {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 32px;
    color: #663301;
  }
  &-info {
    font-size: 24px;
    color: #828282;
    line-height: 26px;
  }
  &-content {
    padding-top: 32px;
    font-size: 20px;
    color: #4f4f4f;
    line-height: 32px;
  }
}
h3{
  font-size: 28px;
  color: #663301;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    font-size: 16px;
  }
}
.box1{
  padding: 50px 50px 0 ;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    padding: 0;
  }
}
.look{
  display: flex;
  flex-wrap: wrap;
}
.lineFont{
  width: 100%;
  word-break: break-all;
}
.lineFont:hover{
  cursor: pointer;
}
</style>
